import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { EuiSpacer } from "@elastic/eui";
import SuccessBox from 'components/Web_User_Interface/1440p_Series/Recording/Relay_Schedule/SuccessBox';
import PermissionBox from 'components/Web_User_Interface/1440p_Series/_permissions/AlarmPerm';
import ScheduleTable from 'components/Web_User_Interface/1440p_Series/Recording/Relay_Schedule/relaySheduleTable';
import BreadCrumbs from "components/Layout/BreadCrumbs";
import SEOHelmet from "components/Layout/SEOHelmet";
export const _frontmatter = {
  "title": "Aufgaben Menü // Relais Zeitplan",
  "path": "/Web_User_Interface/1440p_Serie/Aufnahme_Aufgaben/Relais_Zeitplan/",
  "dateChanged": "2024-09-19",
  "author": "Mike Polinowski",
  "excerpt": "Legen Sie einen Zeitplan für das Alarmausgangsrelais Ihrer Kamera für Wochentage und Tageszeiten fest. Verwenden Sie das Kamerarelais zum Schalten externer Geräte.",
  "image": "./WebUI_1440p_SearchThumb_Tasks_Relay_Schedule.png",
  "social": "/images/Search/WebUI_1440p_SearchThumb_Tasks_Relay_Schedule.webp",
  "toc": "/images/Search/TOC_Icons/Wiki_Tiles_WebUI_white.webp",
  "chapter": "1440p Web User Interface"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <SEOHelmet title="Aufgaben Menü // Relais Zeitplan" dateChanged="2024-09-19" author="Mike Polinowski" tag="INSTAR IP Camera" description="Legen Sie einen Zeitplan für das Alarmausgangsrelais Ihrer Kamera für Wochentage und Tageszeiten fest. Verwenden Sie das Kamerarelais zum Schalten externer Geräte." image='/images/Search/WebUI_1440p_SearchThumb_Tasks_Relay_Schedule.png' twitter='/images/Search/WebUI_1440p_SearchThumb_Tasks_Relay_Schedule.webp' location={props.location.pathname} mdxType="SEOHelmet" />
    <BreadCrumbs locationBC={props.location} locationDE={props.location.pathname} locationEN="/en/Web_User_Interface/1440p_Series/Recording/Relay_Schedule/" locationFR="/fr/Web_User_Interface/1440p_Series/Recording/Relay_Schedule/" crumbLabel="Video" mdxType="BreadCrumbs" />
    <h1 {...{
      "id": "ultrahd-serien-2k-1440p--4k-2160p",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#ultrahd-serien-2k-1440p--4k-2160p",
        "aria-label": "ultrahd serien 2k 1440p  4k 2160p permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`UltraHD Serien (2K+ 1440p & 4K 2160p)`}</h1>
    <h2 {...{
      "id": "aufgaben-menü",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#aufgaben-men%C3%BC",
        "aria-label": "aufgaben menü permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Aufgaben Menü`}</h2>
    <EuiSpacer mdxType="EuiSpacer" />
    <SuccessBox mdxType="SuccessBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <PermissionBox mdxType="PermissionBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <h3 {...{
      "id": "konfigurieren-eines-zeitplans-für-das-alarmrelais",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#konfigurieren-eines-zeitplans-f%C3%BCr-das-alarmrelais",
        "aria-label": "konfigurieren eines zeitplans für das alarmrelais permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Konfigurieren eines Zeitplans für das Alarmrelais`}</h3>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/098b68185435d1055e91652bc8a5c4cf/47aef/1440p_Settings_Task_Relay_Schedule.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "48.26086956521739%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAA7rAAAO6wFxzYGVAAACZElEQVQoz2WQS08TARRG+ReyJGqntAMaLIVoO9N5lM5Mp9N2Hh0aC2hI1Iig8VGsjwCamHThEzagUUANiugGYuJCTYy6cGH0Hx3tqGHh4uTm5ibnfvd2iaKI2NdHr7CPYfs4xUtP0c8sk59eIXd6+T/k08sUZlawzz/iwLCKZYzQ09NDd/eeqHYlk0lEsQ9h/15ylUkacxuErSfUr65Tu9JhjaC1RnB5NcK/vBrNxm9sks1XkCWZ/v6DiMl+Egnxn1BEEAQyh4dohNWI0C0RujZ136FWsfBKBfyyie8YuGUbN6hTMqooch5VyaOpBdKDw3RFJ4sisVgMWc6x+WqLz1++8mBxiUrVpTE+wdHGGGPjEzjlCoZpYVpFLKtIw6tTNFRURUOWdFKHhv4k7NARSpJEq9ViYWGBZrOJ53mEYRgxOlqPFjilEuWIMlOTDqO1HHJWISfruwk7wujkTAbHdrAsC9u2cV33D9UKrmPhV2wqNR+7FlANQ86eMKjaEoqsMKJppNNDf4ViEiEmICkS9ak6tSAgCAJ83yfwXPz6BN50G+fUTc4YZW7pBjOFIkuzU4yWNNScTCGvMTiY3k0Yj8cZODRANi9RGDExDTP6la6PYJZrnLvWZm7pGet3H7A1e4GHV66xc+8OM56JJMtoik4qld79YSKRIC4IxGNxskdyZDMquqIx7hVZazf5tr3K6+fr/Pz+iY/bL/nxfod3jxeZP2ZSyKvkZI3B1NBuwt7e3ohOnzmiYGg6k77B/EmPF+2LfN5+zoe3b1i6Ncf9+ets3muzcfsmzTBPWC0gZVVSv4W/AAzRiV4PoamVAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/098b68185435d1055e91652bc8a5c4cf/e4706/1440p_Settings_Task_Relay_Schedule.avif 230w", "/de/static/098b68185435d1055e91652bc8a5c4cf/d1af7/1440p_Settings_Task_Relay_Schedule.avif 460w", "/de/static/098b68185435d1055e91652bc8a5c4cf/7f308/1440p_Settings_Task_Relay_Schedule.avif 920w", "/de/static/098b68185435d1055e91652bc8a5c4cf/29832/1440p_Settings_Task_Relay_Schedule.avif 1063w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/098b68185435d1055e91652bc8a5c4cf/a0b58/1440p_Settings_Task_Relay_Schedule.webp 230w", "/de/static/098b68185435d1055e91652bc8a5c4cf/bc10c/1440p_Settings_Task_Relay_Schedule.webp 460w", "/de/static/098b68185435d1055e91652bc8a5c4cf/966d8/1440p_Settings_Task_Relay_Schedule.webp 920w", "/de/static/098b68185435d1055e91652bc8a5c4cf/0ca5b/1440p_Settings_Task_Relay_Schedule.webp 1063w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/098b68185435d1055e91652bc8a5c4cf/81c8e/1440p_Settings_Task_Relay_Schedule.png 230w", "/de/static/098b68185435d1055e91652bc8a5c4cf/08a84/1440p_Settings_Task_Relay_Schedule.png 460w", "/de/static/098b68185435d1055e91652bc8a5c4cf/c0255/1440p_Settings_Task_Relay_Schedule.png 920w", "/de/static/098b68185435d1055e91652bc8a5c4cf/47aef/1440p_Settings_Task_Relay_Schedule.png 1063w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/098b68185435d1055e91652bc8a5c4cf/c0255/1440p_Settings_Task_Relay_Schedule.png",
              "alt": "Web User Interface - 1440p Series - Recording",
              "title": "Web User Interface - 1440p Series - Recording",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <EuiSpacer mdxType="EuiSpacer" />
    <ScheduleTable mdxType="ScheduleTable" />
    <EuiSpacer mdxType="EuiSpacer" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      